import { useMutation } from "@tanstack/react-query";
import { useToast } from "../../../components/ui/use-toast";
import { getOTP } from "../../../services/auth";

export function useGetOTP() {
  const { toast } = useToast();

  const { mutate, isPending, data } = useMutation({
    mutationFn: getOTP,
    onSuccess: () => {
      toast({
        title: "OTP sent successfully",
      });
    },
    onError: () => {
      toast({
        title: "Failed to send OTP",
        variant: "destructive",
      });
    },
  });

  return {
    getOTP: mutate,
    data,
    isPending,
  };
}
